import React from 'react';
import classNames from 'classnames';

import { ImageComponentProps } from '../types';

import GoldenLineImage from '../../../images/goldenline.svg';
import styles from '../SocialMedia.module.scss';

export const GoldenLine: React.FC<ImageComponentProps> = ({ className, alt, ...props }) => (
  <img className={classNames(styles.GoldenLine, className)} alt={alt || ''} src={GoldenLineImage} {...props} />
);
